import { render, staticRenderFns } from "./CreateProfile.vue?vue&type=template&id=13206978"
import script from "./CreateProfile.vue?vue&type=script&lang=js"
export * from "./CreateProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports